import checkModule from "../views/shared/checkModule";
import Settings from "./settings.service";
import Storage from "./storage.service";

var Common = {};
Common.setThemeValues = (response) => {
    if (checkModule.isAppVariableKw) {
        const placeholder_images = response.data.placeholder_images;
        const stf_predefined_img = response.data.stf_predefined_img;
        const stf_predefined_img_for_mobile = response.data.stf_predefined_img_for_mobile;
        const stf_cards_banner_img_mobile = response.data.stf_cards_banner_img_mobile;
        const stf_streaming_img = response.data.stf_streaming_img;
        const stf_cards_banner_bg = response.data.stf_cards_banner_bg;
        const stf_banner_streaming = response.data.stf_banner_streaming;
        const stf_cards_banner_img = response.data.stf_cards_banner_img;
        const content_services = response.data.content_services;
        const content_services_description = response.data.content_services_description;
        const stf_vanity_img = response.data.stf_vanity_img;
        const plan_colors = response.data.plan_colors;
        const stf_category_icons = response.data.stf_category_icons;
        const stf_category_topup_color = response.data.stf_category_topup_color;
        const stf_category_topup_img = response.data.stf_category_topup_img;
        Storage.set("stf_category_topup_img", JSON.stringify(stf_category_topup_img), true);
        Storage.set("stf_category_topup_color", JSON.stringify(stf_category_topup_color), true);
        Storage.set("placeholder_images", JSON.stringify(placeholder_images), true);
        Storage.set("stf_predefined_img", JSON.stringify(stf_predefined_img), true);
        Storage.set("stf_predefined_img_for_mobile", JSON.stringify(stf_predefined_img_for_mobile), true);
        Storage.set("stf_cards_banner_img_mobile", JSON.stringify(stf_cards_banner_img_mobile), true);
        Storage.set("stf_streaming_img", JSON.stringify(stf_streaming_img), true);
        Storage.set("content_services", JSON.stringify(content_services), true);
        Storage.set("stf_cards_banner_bg", JSON.stringify(stf_cards_banner_bg), true);
        Storage.set("stf_banner_streaming", JSON.stringify(stf_banner_streaming), true);
        Storage.set("stf_cards_banner_img", JSON.stringify(stf_cards_banner_img), true);
        Storage.set("content_services_description", JSON.stringify(content_services_description), true);
        Storage.set("stf_vanity_img", JSON.stringify(stf_vanity_img), true);
        Storage.set("stf_category_icons", JSON.stringify(stf_category_icons), true);
        Storage.set("plan_colors", JSON.stringify(plan_colors), true);
        Storage.set("plan_font_colors", JSON.stringify(response.data.plan_font_colors), true);
        Storage.set("freeplan_promotion_images", JSON.stringify(response.data.freeplan_promotion_images), true);
        Storage.set("predefinedplan_images", JSON.stringify(response.data.predefinedplan_images), true);
        let theme = response.data.Vanities;
        theme["created_at"] = Date.parse(new Date());
        theme["version"] = Settings["theme_version"];
        Storage.set("theme", JSON.stringify(theme), true);
        response.data.freeplan_promotion_images["created_at"] =
            theme["created_at"];
        response.data.freeplan_promotion_images["version"] = theme["version"];
        Storage.set("themeLoading", false);
    }
    if (checkModule.isAppVariableKsa) {
        const placeholder_images = response.data.placeholder_images;
        const anghami_promotion_images = response.data.anghami_promotion_images;
        const predefinedplan_images = response.data.predefinedplan_images;
        const stf_predefined_img = response.data.stf_predefined_img;
        const stf_predefined_img_for_mobile = response.data.stf_predefined_img_for_mobile;
        const stf_cards_banner_img_mobile = response.data.stf_cards_banner_img_mobile;
        const stf_category_topup_img = response.data.stf_category_topup_img;
        const stf_predefined_plan_fg_images = response.data.stf_predefined_plan_fg_images;
        const predefined_plan_fg_images = response.data.predefined_plan_fg_images
        const stf_streaming_img = response.data.stf_streaming_img;
        const stf_cards_banner_bg = response.data.stf_cards_banner_bg;
        const stf_banner_streaming = response.data.stf_banner_streaming;
        const stf_cards_banner_img = response.data.stf_cards_banner_img;
        const offers_advertising = response.data.offers_advertising;
        const offers_images = response.data.offers_images;
        const content_services = response.data.content_services;
        const content_services_description = response.data.content_services_description;
        const stf_vanity_img = response.data.stf_vanity_img;
        const plan_colors = response.data.plan_colors;
        const stf_category_icons = response.data.stf_category_icons;
        const stf_offer_banner_images = response.data.stf_offer_banner_images;
        const stf_eligibility_tab = response.data.stf_eligibility_tab;
        const stf_category_topup_color = response.data.stf_category_topup_color;
        const information_popup_images = response.data.information_popup_images;
        const sf_plan_card_colors = response.data.sf_plan_card_colors; 
        Storage.set("placeholder_images", JSON.stringify(placeholder_images), true);
        Storage.set("stf_offer_banner_images", JSON.stringify(stf_offer_banner_images), true);
        Storage.set("anghami_promotion_images", JSON.stringify(anghami_promotion_images), true);
        Storage.set("predefinedplan_images", JSON.stringify(predefinedplan_images), true);
        Storage.set("predefined_plan_fg_images", JSON.stringify(predefined_plan_fg_images), true);
        Storage.set("stf_predefined_img", JSON.stringify(stf_predefined_img), true);
        Storage.set("stf_predefined_img_for_mobile", JSON.stringify(stf_predefined_img_for_mobile), true);
        Storage.set("stf_cards_banner_img_mobile", JSON.stringify(stf_cards_banner_img_mobile), true);
        Storage.set("stf_category_topup_img", JSON.stringify(stf_category_topup_img), true);        
        Storage.set("stf_predefined_plan_fg_images", JSON.stringify(stf_predefined_plan_fg_images), true);
        Storage.set("stf_streaming_img", JSON.stringify(stf_streaming_img), true);
        Storage.set("offers_advertising", JSON.stringify(offers_advertising), true);
        Storage.set("offers_images", JSON.stringify(offers_images), true);
        Storage.set("content_services", JSON.stringify(content_services), true);
        Storage.set("stf_cards_banner_bg", JSON.stringify(stf_cards_banner_bg), true);
        Storage.set("stf_banner_streaming", JSON.stringify(stf_banner_streaming), true);
        Storage.set("stf_cards_banner_img", JSON.stringify(stf_cards_banner_img), true);
        Storage.set("content_services_description", JSON.stringify(content_services_description), true);
        Storage.set("stf_vanity_img", JSON.stringify(stf_vanity_img), true);
        Storage.set("plan_colors", JSON.stringify(plan_colors), true);
        Storage.set("stf_category_icons", JSON.stringify(stf_category_icons), true);
        Storage.set("stf_eligibility_tab", JSON.stringify(stf_eligibility_tab), true);
        Storage.set("stf_category_topup_color", JSON.stringify(stf_category_topup_color), true);
        Storage.set("information_popup_images", JSON.stringify(information_popup_images), true);
        Storage.set("sf_plan_card_colors", JSON.stringify(sf_plan_card_colors), true);
        
        let theme = response.data.Vanities;
        theme["created_at"] = Date.parse(new Date());
        theme["version"] = Settings["theme_version"];

        Storage.set("theme", JSON.stringify(theme), true);
        response.data.freeplan_promotion_images["created_at"] =
            theme["created_at"];
        response.data.freeplan_promotion_images["version"] = theme["version"];
        Storage.set(
            "freeplan_promotion_images",
            JSON.stringify(response.data.freeplan_promotion_images),
            true
        );
        Storage.set("themeLoading", false);
    }
    // Common
    const stf_cards_banner_bg_color = response.data.stf_cards_banner_bg_color;
    const stf_cards_banner_text_color = response.data.stf_cards_banner_text_color;
    stf_cards_banner_bg_color && Storage.set("stf_cards_banner_bg_color", JSON.stringify(stf_cards_banner_bg_color), true);
    stf_cards_banner_text_color && Storage.set("stf_cards_banner_text_color", JSON.stringify(stf_cards_banner_text_color), true);
}


export default Common;